<template>
  <div class="d-flex justify-content-start align-items-center">
    <span>{{ value(params.data) }}</span>
    <fa-icon @click="openReasonModal" class="ml-1" style="color: var(--blue); cursor: pointer;" v-if="params.data.cameraReason || params.data.cameraReasonId" icon="info-circle" />
    <b-modal
        :id="`modal-reason-${params.column.colId}-${params.data._id}`"
        :no-close-on-backdrop="false"
        centered
        size="sm"
        title=""
        :is-valid="false"
        :hide-footer="true"
    >
      <b-form style="padding: 15px 0; font-weight: bold; color: #000;" class="d-flex flex-column" v-if="params.data.cameraReason || params.data.cameraReasonId">
        <div class="detectedCarRegNoInfo" v-if="detectedCarRegNo">Ընթերցել է՝ {{ detectedCarRegNo }}</div>
        <p class="m-0">{{ params.data.cameraReasonId }}</p>
        <p class="m-0">{{ params.data.cameraReason }}</p>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import techServiceModule from '@/store/tech-service/techServiceModule'
import store from '@/store'
import {BForm, BModal} from "bootstrap-vue";

export default {
  name: 'cell-renderer-car-reg-no',
  components: {BForm, BModal},
  computed: {
    value() {
      return data => {
        const { CarRegNo, YellowCarRegNo, autoDetection } = data
        const yellow = YellowCarRegNo ? ` (${YellowCarRegNo.toUpperCase()})` : ''
        return `${autoDetection ? '✅' : '❌'} ${CarRegNo}${yellow}`
      }
    },

    detectedCarRegNo() {
      const match = this.params.data.camera.match(/\/([A-Z0-9]+)_attachment-/);
      return match ? match[1] : null;
    },
  },
  methods: {
    openReasonModal() {
      console.log('ok')
      console.log(`modal-reason-${this.params.column.colId}-${this.params.data._id}`)
      this.$bvModal.show(`modal-reason-${this.params.column.colId}-${this.params.data._id}`)
    },
  },
}
</script>

<style>
.detectedCarRegNoInfo {
  color: #fff;
  font-weight: bold;
  background: #052A75;
  padding: 14px;
  width: 183px;
  margin-bottom: 20px;
}
</style>
